/*
  Cart Drawer Upsell — handles carousel, variant image swap, and add-to-cart.
  Lives in assets/ so it loads once at page load and survives drawer rerenders.
*/
(function () {
  'use strict';

  function getCtx() {
    var root = document.querySelector('[data-upsell-root]');
    if (!root) return null;
    var ctx = {
      root: root,
      track: root.querySelector('[data-upsell-track]'),
      cards: root.querySelectorAll('[data-upsell-card]'),
      prev: root.querySelector('[data-upsell-prev]'),
      next: root.querySelector('[data-upsell-next]')
    };
    if (!ctx.track || !ctx.cards.length) return null;
    return ctx;
  }

  function applyState(ctx) {
    var idx = typeof ctx.root.__museIndex === 'number' ? ctx.root.__museIndex : 0;
    if (idx < 0) idx = 0;
    if (idx > ctx.cards.length - 1) idx = ctx.cards.length - 1;
    ctx.root.__museIndex = idx;
    ctx.track.style.transform = 'translateX(-' + (idx * 100) + '%)';
    if (ctx.prev) {
      if (idx === 0) ctx.prev.setAttribute('disabled', '');
      else ctx.prev.removeAttribute('disabled');
    }
    if (ctx.next) {
      if (idx >= ctx.cards.length - 1) ctx.next.setAttribute('disabled', '');
      else ctx.next.removeAttribute('disabled');
    }
  }

  function syncCarousel() {
    var ctx = getCtx();
    if (!ctx) return;
    if (ctx.cards.length <= 1) {
      if (ctx.prev) ctx.prev.style.display = 'none';
      if (ctx.next) ctx.next.style.display = 'none';
      return;
    }
    if (ctx.prev) ctx.prev.style.display = '';
    if (ctx.next) ctx.next.style.display = '';
    if (!ctx.root.dataset.museSynced) {
      ctx.root.__museIndex = 0;
      ctx.root.dataset.museSynced = '1';
    }
    applyState(ctx);
  }

  // Arrows (event delegation — survives DOM replacement)
  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-upsell-prev]');
    var nextBtn = e.target.closest('[data-upsell-next]');
    if (!prevBtn && !nextBtn) return;
    e.preventDefault();
    if (prevBtn && prevBtn.hasAttribute('disabled')) return;
    if (nextBtn && nextBtn.hasAttribute('disabled')) return;
    var ctx = getCtx();
    if (!ctx) return;
    var idx = typeof ctx.root.__museIndex === 'number' ? ctx.root.__museIndex : 0;
    if (prevBtn && idx > 0) {
      ctx.root.__museIndex = idx - 1;
      applyState(ctx);
    } else if (nextBtn && idx < ctx.cards.length - 1) {
      ctx.root.__museIndex = idx + 1;
      applyState(ctx);
    }
  });

  // Variant change → image swap
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel || sel.tagName !== 'SELECT') return;
    var card = sel.closest('[data-upsell-card]');
    if (!card) return;
    var img = card.querySelector('[data-upsell-img]');
    var opt = sel.options[sel.selectedIndex];
    var src = opt && opt.dataset ? opt.dataset.image : '';
    if (img && src && src !== img.getAttribute('src')) {
      img.style.opacity = '0.4';
      var temp = new Image();
      temp.onload = function () {
        img.src = src;
        img.style.opacity = '1';
      };
      temp.src = src;
    }
  });

  // Add to cart
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-upsell-card]');
    var sel = card && card.querySelector('[data-variant-select]');
    if (!sel || !sel.value) return;
    var variantId = parseInt(sel.value, 10);
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    var cartItems = document.querySelector('m-cart-items');
    var sectionsParam = '';
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      var ids = cartItems.getSectionsToRender().map(function (s) { return s.id; });
      var seen = {};
      sectionsParam = ids.filter(function (v) {
        if (seen[v]) return false;
        seen[v] = true;
        return true;
      }).join(',');
    }

    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionsParam) body.sections = sectionsParam;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        if (cartItems && typeof cartItems.onCartRefresh === 'function') {
          cartItems.onCartRefresh();
        }
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = original;
        }, 1500);
      });
  });

  // Touch swipe support (mobile)
  var touchState = { startX: 0, startY: 0, deltaX: 0, active: false };

  document.addEventListener('touchstart', function (e) {
    var viewport = e.target.closest('[data-upsell-viewport]');
    if (!viewport) return;
    touchState.startX = e.touches[0].clientX;
    touchState.startY = e.touches[0].clientY;
    touchState.deltaX = 0;
    touchState.active = true;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!touchState.active) return;
    touchState.deltaX = e.touches[0].clientX - touchState.startX;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!touchState.active) return;
    touchState.active = false;
    var dx = touchState.deltaX;
    var dy = e.changedTouches[0].clientY - touchState.startY;
    // Only horizontal swipes; min 30px; horizontal must dominate
    if (Math.abs(dx) < 30 || Math.abs(dx) <= Math.abs(dy)) return;
    var ctx = getCtx();
    if (!ctx) return;
    var idx = typeof ctx.root.__museIndex === 'number' ? ctx.root.__museIndex : 0;
    if (dx < 0 && idx < ctx.cards.length - 1) {
      ctx.root.__museIndex = idx + 1;
      applyState(ctx);
    } else if (dx > 0 && idx > 0) {
      ctx.root.__museIndex = idx - 1;
      applyState(ctx);
    }
  }, { passive: true });

  // MutationObserver: re-sync when a new upsell root is injected (drawer rerender)
  function startObserver() {
    var observer = new MutationObserver(function () {
      var root = document.querySelector('[data-upsell-root]');
      if (root && !root.dataset.museSynced) {
        syncCarousel();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncCarousel();
      startObserver();
    });
  } else {
    syncCarousel();
    startObserver();
  }

  // Expose for manual sync if needed
  window.__museUpsellSync = syncCarousel;
})();
